{
  "ui": {
    "feedback": "Повратне информације",
    "credits": "Заслуге",
    "currentMaintainer": "Тренутно одржавање",
    "maintainerPeriod": "Од 2026. надаље",
    "originalTeam": "Првобитни тим",
    "creditsCampaigns": "Џунгла и Божић",
    "moreSettings": "Још подешавања",
    "chooseLanguage": "Изабери језик",
    "notebookTools": "Алатке свеске",
    "visualGuide": "Сликовни водич",
    "templeSoon": "Ускоро",
    "playAdventure": "Играј",
    "story": "Прича",
    "loadingAdventure": "Спремамо се за авантуру…",
    "storyOpening": "Школски излет у џунглу. Марко и Софија истражују са другарима. Шарена птица привлачи Маркову пажњу и он је прати међу дрвеће. Одједном је сам. Помози истраживачима да пронађу пут!",
    "storyEnding": "Марко и Софија заједно стижу до изгубљеног храма. Тајанствено лице чува улаз. Чека их нова авантура!",
    "blockCategories": "Картице свеске",
    "actions": "Радње",
    "loops": "Петље",
    "conditions": "Услови",
    "title": "Run Marco! — Авантура у твојој свесци",
    "home": "Почетна страна Run Marco",
    "map": "Мапа авантуре",
    "worlds": "Изабери авантуру",
    "notebook": "Моја свеска",
    "notebookToggle": "Отвори или затвори свеску",
    "notebookOpen": "Отвори свеску",
    "notebookClose": "Посматрај стазу",
    "page": "Страна {number}",
    "level": "Стаза {number}",
    "run": "Кренимо!",
    "stop": "Заустави",
    "step": "Један корак",
    "stepTitle": "Изврши једну наредбу",
    "reset": "Назад на почетак",
    "add": "Додај",
    "addLabel": "Изабери блок за додавање",
    "addHint": "Споји блокове па притисни Играј.",
    "undo": "Опозови",
    "clear": "Нова страна",
    "hint": "Мали савет",
    "help": "Како се игра",
    "settings": "Подешавања",
    "language": "Језик игре",
    "blockLanguage": "Језик блокова",
    "blockLanguageNote": "За блокове можеш да изабереш други језик.",
    "musicOn": "Укључи звук",
    "musicOff": "Искључи звук",
    "sound": "Музика и звучни ефекти",
    "speed": "Брзина авантуре",
    "chooseExplorer": "Изабери истраживача",
    "explorer": "Истраживач",
    "marco": "Марко",
    "sophia": "Софија",
    "close": "Затвори",
    "done": "Истражујмо!",
    "loading": "Тражимо стазу…",
    "loadError": "Авантура није могла да се учита. Освежи страницу и покушај поново.",
    "imageError": "Неке слике нису могле да се учитају. Освежи страницу.",
    "gemGoal": "Пронађи драгуљ",
    "goal": "Пронађи златну звезду",
    "cover": "Осветли свако поље само једном",
    "lit": "Осветљена поља: {count} / {total}",
    "explored": "Истражене стазе: {count} / {total}",
    "facing": "Гледа {direction} {arrow}",
    "boardLabel": "{name} на стази {level}, гледа {direction}. {steps}. {objective}.",
    "up": "горе",
    "down": "доле",
    "left": "лево",
    "right": "десно",
    "steps_one": "{count} корак",
    "steps_other": "{count} корака",
    "blocks_one": "{count} блок",
    "blocks_other": "{count} блокова",
    "stars_one": "{count} звезда",
    "stars_other": "{count} звезда",
    "place": "Додај блокове",
    "atEnd": "На крај",
    "insideRepeat": "Унутар понављања {number}",
    "insideIf": "Унутар ако {number}",
    "insideElse": "Унутар иначе {number}",
    "readyFirst": "Један мали корак. Додај блок напред и кренимо!",
    "ready": "Куда идемо? Направи план у свесци.",
    "back": "Опет на почетку. Блокови су спремни за нови покушај.",
    "empty": "Прво додај блок у свеску.",
    "win": "Пут је пронађен!",
    "winCover": "Цела стаза светли!",
    "winDetails": "{steps} · {blocks}",
    "brilliant": "Каква авантура!",
    "simpler": "Можеш ли да употребиш мање блокова?",
    "complete": "Стаза завршена! Твоје најбоље звезде су сачуване.",
    "next": "Следећа стаза",
    "allWorlds": "Још авантура",
    "replay": "Играј поново",
    "shortGoal": "Скоро! Додај још блокова да стигнеш до звезде.",
    "shortGem": "Скоро! Додај још блокова да стигнеш до драгуља.",
    "shortCover": "Нека поља су још тамна. Како да стигнемо до њих?",
    "checking": "Посматрамо стазу…",
    "paused": "Заустављено. Играј почиње поново од почетка.",
    "going": "На пут!",
    "stepped": "Корак ближе. Притисни Један корак или Играј за наставак.",
    "clueCover": "Крени од ивице и обиђи цео облик. Скоком можеш да прескочиш поље без осветљавања.",
    "clueCondition": "Погледај стазу испред себе. Услов помаже истраживачу да изабере шта да уради.",
    "clueRepeat": "Који кораци се понављају? Стави тај образац у блок понављања.",
    "clueForward": "Напред прати правац истраживачевог погледа. Преброј поља до звезде.",
    "clueGem": "Напред прати правац истраживачевог погледа. Преброј поља до драгуља.",
    "clueTurn": "Окрет мења правац без померања. Прати стазу прстом.",
    "mapNote": "Изабери стазу. Твоје најбоље звезде остају сачуване.",
    "mapLevel": "Стаза {number}: {name}. {stars}.",
    "locked": "Заврши претходну стазу да откључаш ову.",
    "soundBlocked": "Додирни дугме за звук да чујеш авантуру.",
    "clearTitle": "Отворити нову страну?",
    "clearNote": "Блокови ове стазе биће обрисани. Опозови може да их врати.",
    "keep": "Задржи моје блокове",
    "clearConfirm": "Обриши блокове",
    "fresh": "Нова страна. Куда ће нас одвести твој следећи план?",
    "localProgress": "Твој напредак се чува на овом уређају.",
    "helpBuild": "Направи план",
    "helpBuildText": "Превуци блокове у свеску и споји их или додирни блок за додавање. Изабери „Унутар понављања” за кораке у петљи.",
    "helpTurn": "Прати истраживача",
    "helpTurnText": "Напред прати поглед. Лево и десно окрећу у месту. Скок прелази два поља.",
    "helpTry": "Покушај, посматрај и покушај поново",
    "helpTryText": "Притисни Играј за план или Један корак за једну наредбу. Закривљена стрелица враћа на почетак и чува блокове.",
    "helpWorlds": "Свака пустоловина има циљ",
    "helpWorldsText": "У Џунгли пронађи драгуљ. У божићној пустоловини осветли свако слободно поље једном. У Храму и Егејском мору доврши поправке и видљиве циљеве па стигни до излаза.",
    "noTrail": "Тамо нема стазе! Покушај прво да се окренеш.",
    "broken": "Тај мост је поломљен. Можеш ли да га прескочиш?",
    "blocked": "Нешто блокира пут. Покушај скок или други пут.",
    "alreadyLit": "То поље већ светли. Посети свако поље само једном.",
    "loopError": "Овај план се стално понавља. Покушај да промениш петљу.",
    "repeatError": "Изабери број понављања од 1 до 99.",
    "unsupported": "Уклони неподржани блок и покушај поново.",
    "connect": "Споји блокове у један ланац па притисни Играј.",
    "path": "стаза",
    "steps_few": "{count} корака",
    "blocks_few": "{count} блока",
    "stars_few": "{count} звезде",
    "backpack": "Ранац",
    "templeGems": "Драгуљи храма",
    "gemsCollected": "Драгуљи: {count} / {total}",
    "gemsReady": "Сви драгуљи су сакупљени!",
    "aegeanTitle": "Тајне Егејског мора",
    "harbour": "Лука",
    "aegeanDescription": "Истражи луку: поправљај станице, поново користи потпрограме и уз сваки налог пошаљи број.",
    "templeBetaNote": "Бета · Загонетке и лекције се дорађују",
    "aegeanBetaNote": "Бета · Прва 3 нивоа у луци",
    "seasonal": "Сезонска пустоловина",
    "choosePreview": "Изабери пробни ниво",
    "repairs": "Поправке",
    "reachExit": "Стигни до излаза",
    "taskRequirements": "Циљеви задатка",
    "lessonGuided": "Вођена вежба · допуни припремљени програм",
    "lessonRepair": "Отклањање грешака · исправи припремљени програм",
    "lessonChallenge": "Изазов · направи свој програм",
    "acc_define_parameter": "Потпрограм",
    "acc_call_argument": "Позови потпрограм",
    "acc_repeat_parameter": "Понављај према улазу",
    "parameter": "параметар",
    "argument": "пошаљи",
    "callInput": "Улаз овог позива",
    "inputWaiting": "Покрени програм или изврши једну наредбу да видиш следећи улаз.",
    "argumentMismatch": "Потпрограму са параметром потребан је позив са бројем. Без параметра користи обичан позив.",
    "unsetParameter": "Параметар користи само у потпрограму који га прима. Параметри су одвојени од заједничке меморије.",
    "memoryObjective": "Провери запис поправки и услове излаза. Прихвата се сваки програм који их испуњава.",
    "gate": "Пут је блокиран. Провери недовршене поправке.",
    "noPickup": "Стани на алат пре него што га покупиш.",
    "creditLead": "Вођење тима и развој софтвера",
    "creditArt": "Илустрације и сценографија",
    "creditAnimation": "Анимација",
    "creditUX": "Дизајн интерфејса и корисничког искуства",
    "creditDesign": "Дизајн игре",
    "creditStory": "Писање приче",
    "creditAudio": "Музика и тонска техника",
    "lightLamp": "Упали светиљку",
    "oilLamp": "Уљна светиљка",
    "dustyStation": "прашњава станица",
    "betaLabel": "Бета",
    "noLamp": "Стани на угашену лампу пре него што је упалиш.",
    "collected": "Алат преузет · спреман за употребу",
    "dustyPrompt": "Стани на прашњаву станицу пре употребе четкице.",
    "lampMissing": "Прво узми уљну светиљку. Погледај у ранац.",
    "recursiveRoutine": "Овај потпрограм позива сам себе. Користи други потпрограм; рекурзивни позиви још нису доступни."
  },
  "content": {
    "jungle.title": "Експедиција у џунглу",
    "jungle.description": "Прати стазу до изгубљеног храма.",
    "jungle-1": "Први кораци",
    "jungle-2": "Мало даље",
    "jungle-3": "Иза угла",
    "jungle-4": "Промени правац",
    "jungle-5": "Прати стазу",
    "jungle-6": "Нови пут",
    "jungle-7": "Нове стазе",
    "jungle-8": "Раскрсница у џунгли",
    "jungle-9": "Пронађи пут",
    "jungle-10": "Мисли унапред",
    "jungle-11": "Дуга стаза",
    "jungle-12": "Вијугава путања",
    "jungle-13": "Храбар скок",
    "jungle-14": "Појављују се обрасци",
    "jungle-15": "Понови ритам",
    "jungle-16": "Изабери стазу",
    "jungle-17": "Погледај пре скока",
    "jungle-18": "Читај стазу",
    "jungle-19": "Паметан обилазак",
    "jungle-20": "Под крошњама",
    "jungle-21": "Градитељ мостова",
    "jungle-22": "С друге стране реке",
    "jungle-23": "Истражи рушевине",
    "jungle-24": "Камен и дрво",
    "jungle-25": "Већи скок",
    "jungle-26": "Прати трагове",
    "jungle-27": "На виши терен",
    "jungle-28": "Настави да истражујеш",
    "jungle-29": "Вијугаве стазе",
    "jungle-30": "Тајна башта",
    "jungle-31": "Скривени обрасци",
    "jungle-32": "Древне стазе",
    "jungle-33": "Последњи заокрети",
    "jungle-34": "Према храму",
    "jungle-35": "Скоро смо стигли",
    "jungle-36": "Изгубљени храм",
    "winter.title": "Зимска стаза",
    "winter.description": "Осветли сваки отисак стопала.",
    "winter-1": "Кораци у снегу",
    "winter-2": "Други правац",
    "winter-3": "Смрзнути углови",
    "winter-4": "Дуги обилазак",
    "winter-5": "Пахуљица",
    "winter-6": "Зимске петље",
    "winter-7": "Истраживач леда",
    "winter-8": "Кривине и окрети",
    "winter-9": "Ледена логика",
    "winter-10": "Трагач за обрасцима",
    "winter-11": "Мајстор стазе",
    "winter-12": "Зимско чудо",
    "temple.title": "Изгубљени храм",
    "temple.description": "Четрдесет повезаних соба. Обнови небески уређај алатима, меморијом и властитим потпрограмима."
  },
  "blockly": {
    "ARIA_LABEL_TRASH_EMPTY": "Корпа је празна",
    "OPEN_TRASH": "Отвори корпу",
    "BLOCK_LABEL_BEGIN_STACK": "Почетак низа",
    "WORKSPACE_LABEL_1_STACK": "1 низ блокова",
    "WORKSPACE_LABEL_MANY_STACKS": "Низови блокова: %1",
    "ARIA_TYPE_FIELD_NUMBER": "број",
    "ARIA_TYPE_FIELD_DROPDOWN": "падајућа листа",
    "ARIA_TYPE_FIELD_IMAGE": "слика",
    "WORKSPACE_LABEL_PLAIN": "Моја свеска",
    "FIELD_LABEL_EDIT_PREFIX": "Уреди %1",
    "BLOCK_LABEL_HAS_INPUT": "има улаз",
    "BLOCK_LABEL_HAS_INPUTS": "има улазе",
    "BLOCK_LABEL_HAS_BRANCHES": "гране: %1",
    "FIELD_LABEL_OPTION_INDEX": "Опција %1",
    "INPUT_LABEL_EMPTY": "Празно",
    "BLOCK_LABEL_DISABLED": "онемогућено",
    "BLOCK_LABEL_COLLAPSED": "скупљено",
    "BLOCK_LABEL_BEGIN_PREFIX": "Почетак: %1",
    "INPUT_LABEL_END_STATEMENT": "Крај: %1",
    "ARIA_TYPE_FIELD_TEXT_INPUT": "текст",
    "ARIA_TYPE_FIELD_INPUT": "улаз",
    "ARIA_TYPE_FIELD_TEXT_INPUT_ARGUMENT": "назив улаза",
    "ARIA_TYPE_FIELD_TEXT_INPUT_PROCEDURE": "назив потпрограма"
  }
}
